import React from "react";
import { Outlet } from "react-router-dom";
import "./Root.css";
import Nav from "../Nav/Nav";


import { Show } from "../../ModalContext";

const Root = () => {
  return (
    <div>
      <Nav></Nav>
      <Outlet />
    </div>
  );
};

export default Root;
